/**
 * 管理后台：公告管理
 */
import { useState } from 'react';
import { Modal, Form } from 'antd';
import { message } from '../utils/antdMessage';
import dayjs from 'dayjs';

export default function useAdminAnnouncements({ apiRequest }) {
  const [announcements, setAnnouncements] = useState([]);
  const [announcementForm] = Form.useForm();
  const [annModalVisible, setAnnModalVisible] = useState(false);
  const [editingAnn, setEditingAnn] = useState(null);
  const [annMsg, setAnnMsg] = useState('');

  const fetchAnnouncements = async () => {
    const data = await apiRequest('/api/admin/announcements');
    if (data.success) {
      console.log('📋 获取到的公告数据:', data.announcements);
      // 确保日期字段格式正确，保持原始格式
      const formattedAnnouncements = data.announcements.map(ann => ({
        ...ann,
        start_time: ann.start_time || null,
        end_time: ann.end_time || null
      }));
      console.log('📋 格式化后的公告数据:', formattedAnnouncements);
      setAnnouncements(formattedAnnouncements);
    }
  };
  const handleSaveAnn = async (values) => {
    let url, method;
    
    console.log('💾 保存公告，原始值:', values);
    
    // 转换日期格式，保持本地时间
    const formData = {
      ...values,
      start_time: values.start_time ? values.start_time.format('YYYY-MM-DD HH:mm:ss') : null,
      end_time: values.end_time ? values.end_time.format('YYYY-MM-DD HH:mm:ss') : null
    };
    
    console.log('💾 转换后的表单数据:', formData);
    
    if (editingAnn) {
      url = '/api/admin/announcements/update';
      method = 'POST';
      formData.id = editingAnn.id; // 添加ID到请求体
    } else {
      url = '/api/admin/announcements/add';
      method = 'POST';
    }
    
    const data = await apiRequest(url, { method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(formData) });
    if (data.success) {
      message.success('保存成功');
      setAnnModalVisible(false);
      setEditingAnn(null);
      announcementForm.resetFields();
      fetchAnnouncements();
    } else {
      message.error(data.error || '保存失败');
    }
  };
  const handleDeleteAnn = async (id) => {
    Modal.confirm({
      title: '确定要删除该公告吗？',
      onOk: async () => {
        const data = await apiRequest('/api/admin/announcements/delete', { 
          method: 'POST', 
          headers: { 'Content-Type': 'application/json' }, 
          body: JSON.stringify({ id }) 
        });
        if (data.success) fetchAnnouncements();
      }
    });
  };
  const handleEditAnn = (ann) => {
    console.log('🔍 编辑公告，原始数据:', ann);
    
    setEditingAnn(ann);
    setAnnModalVisible(true);
    
    // 转换日期格式，确保DatePicker能正确处理
    const formData = {
      ...ann,
      start_time: ann.start_time ? dayjs(ann.start_time, 'YYYY-MM-DD HH:mm:ss') : null,
      end_time: ann.end_time ? dayjs(ann.end_time, 'YYYY-MM-DD HH:mm:ss') : null
    };
    
    console.log('🔍 转换后的表单数据:', formData);
    console.log('🔍 start_time类型:', typeof formData.start_time, formData.start_time);
    console.log('🔍 end_time类型:', typeof formData.end_time, formData.end_time);
    console.log('🔍 start_time本地时间:', formData.start_time ? formData.start_time.format('YYYY-MM-DD HH:mm:ss') : 'null');
    console.log('🔍 end_time本地时间:', formData.end_time ? formData.end_time.format('YYYY-MM-DD HH:mm:ss') : 'null');
    
    announcementForm.setFieldsValue(formData);
  };

  return {
    announcements, announcementForm, annModalVisible, setAnnModalVisible, editingAnn, setEditingAnn, annMsg,
    fetchAnnouncements, handleEditAnn, handleDeleteAnn, handleSaveAnn
  };
}
